/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { PackagingFragmentFragmentDoc } from './packagingFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Availability_Status_Enum =
  | 'AVAILABLE'
  | 'UNAVAILABLE';

/** Boolean expression to compare columns of type "availability_status_enum". All fields are combined with logical 'AND'. */
export type Availability_Status_Enum_Comparison_Exp = {
  _eq?: Availability_Status_Enum | null | undefined;
  _in?: Array<Availability_Status_Enum> | null | undefined;
  _is_null?: boolean | null | undefined;
  _neq?: Availability_Status_Enum | null | undefined;
  _nin?: Array<Availability_Status_Enum> | null | undefined;
};

export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Gtin_Type_Enum =
  | 'GTIN_8'
  | 'GTIN_12'
  | 'GTIN_13'
  | 'GTIN_14';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type PackagingsByCompanyQueryVariables = Exact<{
  companyId: string;
  skuPackagingsToIgnore?: Array<number> | number | null | undefined;
  availability?: Types.Availability_Status_Enum_Comparison_Exp | null | undefined;
}>;


export type PackagingsByCompanyQuery = { packaging: Array<{ id: string, company_id: string, base_unit_id: string, product_id: string, gtin: string | null, gtin_type: Types.Gtin_Type_Enum | null, sku: number, price: number, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, net_content: number | null, base_unit: { id: string, sku: number | null, billing_type: Types.Billing_Type_Enum, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, unit_type: Types.Base_Unit_Type_Enum | null, unit_quantity: number | null, unit_net_content: number | null, suggested_retail_price: number | null, availability: Types.Availability_Status_Enum, product_id: string, main_photo: { path: string, domain: string | null } | null, photos: Array<{ photo: { path: string, domain: string | null } }>, social_tags: Array<{ values: { [key: string]: any } | null, type: Types.Social_Tag_Type_Enum, priority: number, level: number }> }, product: { name: string, sku: number, sub_family: string, vat_rate: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } }> };


export const PackagingsByCompanyDocument = /*#__PURE__*/ gql`
    query PackagingsByCompany($companyId: uuid!, $skuPackagingsToIgnore: [Int!], $availability: availability_status_enum_comparison_exp = {}) {
  packaging(
    where: {company_id: {_eq: $companyId}, sku: {_nin: $skuPackagingsToIgnore}, base_unit: {availability: $availability}}
    order_by: [{product: {name: asc}}, {base_unit: {unit_type: asc}}, {trade_item_unit_descriptor: asc}]
  ) {
    ...packagingFragment
  }
}
    ${PackagingFragmentFragmentDoc}`;

/**
 * __usePackagingsByCompanyQuery__
 *
 * To run a query within a React component, call `usePackagingsByCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagingsByCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagingsByCompanyQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      skuPackagingsToIgnore: // value for 'skuPackagingsToIgnore'
 *      availability: // value for 'availability'
 *   },
 * });
 */
export function usePackagingsByCompanyQuery(baseOptions: Apollo.QueryHookOptions<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables> & ({ variables: PackagingsByCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>(PackagingsByCompanyDocument, options);
      }
export function usePackagingsByCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>(PackagingsByCompanyDocument, options);
        }
// @ts-ignore
export function usePackagingsByCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>;
export function usePackagingsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<PackagingsByCompanyQuery | undefined, PackagingsByCompanyQueryVariables>;
export function usePackagingsByCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>(PackagingsByCompanyDocument, options);
        }
export type PackagingsByCompanyQueryHookResult = ReturnType<typeof usePackagingsByCompanyQuery>;
export type PackagingsByCompanyLazyQueryHookResult = ReturnType<typeof usePackagingsByCompanyLazyQuery>;
export type PackagingsByCompanySuspenseQueryHookResult = ReturnType<typeof usePackagingsByCompanySuspenseQuery>;
export type PackagingsByCompanyQueryResult = Apollo.QueryResult<PackagingsByCompanyQuery, PackagingsByCompanyQueryVariables>;